import {Component, OnInit, ViewChild, HostListener} from '@angular/core';
import { first } from 'rxjs/operators';
import { VirtualFolderService } from '../_services/virtualFolder.service';
import { VirtualFolderNode } from 'src/app/_models/virtualFolder';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatTableDataSource } from '@angular/material/table';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { User } from '../_models';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from 'src/assets/config/config/app-config';
import { AuthenticationService } from '../_services/authentication.service';
import { DialogDeleteConfirmComponent } from '../dialog-delete-confirm/dialog-delete-confirm.component';
import { MatDialog } from '@angular/material/dialog';

interface FolderFlatNode {
  expandable: boolean;
  id: number;
  folder_name: string;
  parent_id: number;
  level: number;
}

@Component({
  selector: 'app-virtual-folders',
  templateUrl: './virtual-folders.component.html',
  styleUrls: ['./virtual-folders.component.scss'],
})
export class VirtualFoldersComponent implements OnInit {
  // @Output() isCreateFolder = new EventEmitter<boolean>();
  // @Output() isUpdateFolder = new EventEmitter<boolean>();
  noDocuments: any;
  checkFolders: any;
  // folders: any;
  navBarFolders: any[];
  filterValue: string;
  url: string;
  folderDetails: any;
  folders = [];
  selectedFolderName: any;
  selectedFolderId: any;
  folderSelected: boolean = false;
  isMainPage: boolean = false;
  isCreateFolder: boolean = false;
  isCreateSubFolder: boolean = false;
  isUpdateFolder: boolean = false;
  currentUser: User;
  documents: any;
  totalDocumentCount: number = 0;
  offset: number = 0;
  selectedDoc: String;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;
  documentCols: String[] = [];
  docResultsList: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  folderCreated: any;
  //private ithService:ImageTrustService
  width = '100';
  selectedRow: Array<JSON> = [];
  hideDocList: Boolean = false;
  sort;
  iframeUrl = null;
  loading = false;
  displayImageTrust = false;
  allVirtualFolders
  noFolders:boolean = false;
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    public dialog: MatDialog,
    private virtualFolderService: VirtualFolderService,
    private config: AppConfig,
    private authenticationService: AuthenticationService
  ) {
    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/pdf.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'jpeg',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/jpg.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'ppt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/ppt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'xls',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/xls.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'txt',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/txt.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'doc',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/doc.svg')
    );
  }

  ngOnInit() {
    this.getVirtualFoldersTree();
    this.getFlattenedVirtualFolders();
  }

  private _transformer = (node: VirtualFolderNode, level: number) => {
    return {
      expandable: !!node.sub_folders && node.sub_folders.length > 0,
      id: node.id,
      folder_name: node.folder_name,
      level: level,
      parent_id: node.parent_id,
    };
  };
  treeControl = new FlatTreeControl<FolderFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.sub_folders
  );
  virtualFolders = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  hasChild = (_: number, node: FolderFlatNode) => node.expandable;

  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.docResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.docResultsList.paginator = this.paginator;
    }
  }

  // @HostListener('window:message', ['$event'])
  // onClientLoadedAndWindowClosed(event: any): void {
  //   if (typeof event.data == 'string' && event.data.includes('loaded')) {
  //     // this.onHideDocList(false);
  //     this.loading = false;
  //     window.postMessage(
  //       'Thanks for sharing the info with me',
  //       'https://dev-docuedge-review.fxedw.com/'
  //     );
  //   }

  //   if (typeof event.data == 'string' && event.data.includes('close')) {
  //     this.onHideDocList(false);
  //   }
  // }

  async getFlattenedVirtualFolders(){    
      this.allVirtualFolders= await this.virtualFolderService.getFlattenedTree()
  }

  private getVirtualFoldersTree() {
    this.virtualFolderService
      .getTree()
      .pipe(first())
      .subscribe((folders) => {
        if(typeof folders == 'string'){
          this.noFolders = true          
        } else {
          this.noFolders = false
          this.virtualFolders.data = folders;
          this.folders = folders;
          this.navBarFolders = folders;
        }
      });
  }
  applyFilterOnFolders(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.search();
    } else {
      this.virtualFolders.data = this.folders;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.docResultsList.filter = filterValue.trim().toLowerCase();
    if (this.docResultsList.paginator) {
      this.docResultsList.paginator.firstPage();
      this.documentCount = this.docResultsList.filteredData.length;
    }
  }
  createSubFolder() {
    this.isMainPage = true;
    this.isCreateFolder = false;
    this.isUpdateFolder = false;
    this.isCreateSubFolder = true;
  }

  selectFolder(name, id) {
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.isMainPage = false;
    this.selection.clear();
    this.selectedFolderName = name;
    this.selectedFolderId = id;

    this.documentCols = [
      'select',
      'title',
      'create_date',
      'created_by',
      'modified_date',
    ];
    this.virtualFolderService.get(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        this.noDocuments = true;
      } else {
        this.noDocuments = false;
        this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;
        //Get dynamic document columns
        var categoryKeys = documents['results'][0];
        var additionalCols: String[] = [];
        Object.keys(categoryKeys).forEach(function (key) {
          if (key.startsWith('display_')) {
            additionalCols.push(key);
          }
        });

        for (var i = 0; i < additionalCols.length; i++) {
          this.documentCols.push(additionalCols[i]);
        }
        this.docResultsList = new MatTableDataSource(this.documents.results);
        this.docResultsList.sort = this.sort;
        this.docResultsList.paginator = this.paginator;
      }
    });
  }

  updateFolder(id) {
    this.isUpdateFolder = true;
    this.isMainPage = true;
    this.isCreateFolder = false;
    this.isCreateSubFolder = false;
    this.noDocuments = false;
  }

  search() {
    this.folders.filter((form) => {
      if (
        form.folder_name
          .trim()
          .toLowerCase()
          .indexOf(this.filterValue.trim().toLowerCase()) > -1
      ) {
        this.navBarFolders.push(form);
      }
      if (form.sub_folders) {
        form.sub_folders.filter((element) => {
          if (
            element.folder_name
              .trim()
              .toLowerCase()
              .indexOf(this.filterValue.trim().toLowerCase()) > -1
          ) {
            this.navBarFolders.push(form);
          }
        });
      }
      this.navBarFolders = this.navBarFolders.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return elem;
        }
      });
    });
    this.virtualFolders.data = this.navBarFolders;
  }

  getDocDetails(event, docDetails, drawer) {
    this.loading = true;
    this.displayImageTrust = false;
    if (drawer.opened) {
      drawer.toggle();
    }

    if (
      docDetails['documentName'].includes('_redacted') &&
      Object.keys(docDetails).includes('display_Passed Review') &&
      docDetails['display_Passed Review'] === false
    ) {
      this.displayImageTrust = true;
      this.iframeUrl =
        this.config.getConfig('imageTrustUrl') +
        '?docid=' +
        docDetails.documentId +
        '&username=' +
        this.authenticationService.currentUserValue.username +
        '&token=' +
        this.authenticationService.currentUserValue.token +
        '&dms_user=' +
        this.authenticationService.currentUserValue.username;
    }
    this.hideDocList = true;
    this.width = '50';
    this.selectedDoc = docDetails.documentId;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.docResultsList.data.length;
    return numSelected === numRows;
  }

  createFolder() {
    this.isMainPage = true;
    this.isCreateFolder = true;
    this.isCreateSubFolder = false;
    this.isUpdateFolder = false;
    this.folderSelected = false;
  }

  onHideDocList(hide: boolean) {
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      this.drawerContainer.open();
      this.selectFolder(this.selectedFolderName, this.selectedFolderId);
    }
  }
  next() {
    this.offset = this.offset + 200;
    this.selectFolder(this.selectedFolderName, this.selectedFolderId);
  }

  previous() {
    this.offset = this.offset - 200;
    this.selectFolder(this.selectedFolderName, this.selectedFolderId);
  }

  mergeDocuments() {
    // if (environment.apiUrl === "https://km0gvq0iu0.execute-api.us-east-2.amazonaws.com/dev") {
    //   this.ithService.getImageTrustUrl(this.selection.selected.join(), this.currentUser.username, "merge").subscribe(url => {
    //     //window.open(url)
    //     this.url = url.toString()
    //     window.open(this.url, "_blank");
    //   })
    // }

    alert("Merge operation is under maintenence. Please try again in sometime.")
    // var apiUrl = this.config.getConfig('apiUrl');
    // if (
    //   apiUrl === 'https://km0gvq0iu0.execute-api.us-east-2.amazonaws.com/dev'
    // ) {
    //   this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.selection.selected.join()}&dms_user=${
    //     this.currentUser.username
    //   }&token=${this.currentUser.token}&environment=DocuEdge-Dev`;
    //   window.open(this.url, '_blank');
    // } else if (
    //   apiUrl === 'https://il4p364yh4.execute-api.us-east-2.amazonaws.com/dev'
    // ) {
    //   this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.selection.selected.join()}&dms_user=${
    //     this.currentUser.username
    //   }&token=${this.currentUser.token}&environment=DocuEdge-Demo`;
    //   window.open(this.url, '_blank');
    // } else {
    //   alert('Unable to merge, Please contact the system administrator');
    // }
  }

  onReturnPage(hide: boolean) {
    if (hide) {
      this.isMainPage = false;
      this.ngOnInit();
      this.isCreateFolder = false;
      this.isCreateSubFolder = false;
      this.isUpdateFolder = false;
      this.folderSelected = false;
      this.noDocuments = false;
    } else {
      this.isMainPage = false;
      this.isCreateFolder = false;
      this.isCreateSubFolder = false;
      this.isUpdateFolder = false;
      this.folderSelected = false;
      this.noDocuments = false;
    }
  }

  deleteFolder(id) {
    this.allVirtualFolders.find((x) => {
      if (x.id == id) {
        if (x.sub_folders) {
        this.dialog.open(DialogDeleteConfirmComponent,
            { width: '500px', data: { type: "Delete Virtual Folder Warning" } });
        } else {
          // this.virtualFolderService.deleteFolder(id).subscribe((resp) => {
          //   this.ngOnInit();
          // });
          this.dialog.open(DialogDeleteConfirmComponent,
            { width: '500px', data: { type: "Delete Folder", id: id } }).afterClosed().subscribe(refresh=>{       
              this.folderSelected = false;
              this.noDocuments = false;
              this.ngOnInit()
            });
        }
      }
    });
  }
}
